import React from "react";
import PropTypes from "prop-types";
import { FormGroup, Label, Input } from "components/formElements";
import styles from "./FormGroupInput.module.scss";
import { FaExclamationCircle } from "react-icons/fa";

const FormGroupInput = ({
  id,
  label,
  errorMessage,
  inputGroupText,
  inputRef,
  value,
  ...rest
}) => (
  <FormGroup className={styles.formGroupInput}>
    <Input
      id={id}
      inputGroupText={inputGroupText}
      value={value}
      {...rest}
      inputRef={inputRef}
    />
    <Label htmlFor={id} label={label} value={value} />
    <FaExclamationCircle className={`${styles.errorSymbol} errorSymbol`} />
    <span
      className={`${styles.errorMessage} ${styles.errorMessageForInputGroup}`}
    >
      {errorMessage}
    </span>
  </FormGroup>
);

FormGroupInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  inputGroupText: PropTypes.string,
  inputRef: PropTypes.object,
};

export { FormGroupInput };
